import axios from 'axios';
const base = 'contadorvisitas';

function getAll(query = null) {
    return axios.get(base, { params: query });
}

function register(data) {
    return axios.post(base, data);
}

function update(data) {
    return axios.put([base, data?.id_cvt].join('/'), data);
}

const ContadorVisitasTkService = {
    getAll,
    register,
    update
};
export default ContadorVisitasTkService;
